/**
 * Per-device workspaces (folder list the client elects to expose).
 *
 * - GET returns the last-known report cached on the hub (may be null on a
 *   fresh device that has never reported).
 * - POST /refresh long-polls (up to 5 s) for a fresh report from the device.
 *   When the device is offline / didn't reply in time, `stale: true` is set
 *   and the cached report is returned.
 */

import type { WorkspacesReport } from "@paperclip-cloud/shared";
import { api } from "../client";

export const workspacesApi = {
  get: (deviceId: string) =>
    api<{ workspaces: WorkspacesReport | null }>(
      `/v1/devices/${deviceId}/workspaces`,
    ),
  refresh: (deviceId: string) =>
    api<{ workspaces: WorkspacesReport | null; stale: boolean }>(
      `/v1/devices/${deviceId}/workspaces/refresh`,
      { method: "POST" },
    ),
};
